import { createContext, FunctionComponent, ReactElement, useMemo } from "react";
import { useQuery } from "@tanstack/react-query";

import Api from "src/Config";

import { useParams } from "react-router-dom";

export const TransactionDetailContext = createContext(null);

type Props = {
  children: ReactElement;
};

const TransactionDetailProvider: FunctionComponent<Props> = ({ children }) => {
  const { id } = useParams();

  const { data, isLoading, error, isFetching } = useQuery({
    queryKey: ["transaction_detail", id],
    staleTime: 30000,
    queryFn: async () => {
      const {
        data: { data },
      } = await Api.get(`tm/transactions/${id}`);

      return data;
    },
  });

  const contextValue = useMemo(
    () => ({
      isLoading,
      data,
      error,
      isFetching,
    }),
    [isLoading, data, error, isFetching],
  );
  return (
    <TransactionDetailContext.Provider value={contextValue}>
      {children}
    </TransactionDetailContext.Provider>
  );
};

export default TransactionDetailProvider;
